const ENHANCED_ATTR = "data-cookie-prefs-enhanced";

const VENDOR_DATA = {
  preferences: [
    { name: "Shopify", regionKey: "ca", noteKey: "visitor_prefs" },
  ],
  marketing: [
    { name: "Google Ads", regionKey: "us", crossBorder: true },
    { name: "Meta Pixel", regionKey: "us", crossBorder: true },
    { name: "TikTok Ads", regionKey: "us", crossBorder: true },
    { name: "Shopify Audiences", regionKey: "ca" },
  ],
  analytics: [
    { name: "Google Analytics 4", regionKey: "us", crossBorder: true },
    { name: "Shopify Analytics", regionKey: "ca" },
  ],
};

const REGION_FALLBACK = { us: "SUA", ca: "Canada" };
const NOTE_FALLBACK = { visitor_prefs: "preferințe vizitator" };

function t(key, fallback) {
  const raw = window.languages?.[key] ?? fallback;
  return decodeHtmlEntities(raw);
}

function decodeHtmlEntities(s) {
  if (typeof s !== "string") return s;
  if (s.indexOf("&") === -1) return s;
  const txt = document.createElement("textarea");
  txt.innerHTML = s;
  return txt.value;
}

function neutralizeBannerHeading() {
  const h2 = document.querySelector("h2#shopify-pc__banner__body-title");
  if (!h2) return;
  const div = document.createElement("div");
  for (const attr of Array.from(h2.attributes)) {
    div.setAttribute(attr.name, attr.value);
  }
  div.innerHTML = h2.innerHTML;
  h2.replaceWith(div);
}

function enhanceDialog(dialog) {
  if (dialog.getAttribute(ENHANCED_ATTR) === "true") return;
  dialog.setAttribute(ENHANCED_ATTR, "true");

  injectTrustBadges(dialog);
  injectNecesarLegalNote(dialog);
  injectVendorAccordions(dialog);
  reorganizeFooter(dialog);
  injectLegalFoot(dialog);
}

function injectTrustBadges(dialog) {
  const header = dialog.querySelector("header");
  if (!header || header.querySelector(".shopify-pc__prefs__trust-badges")) return;

  const wrap = document.createElement("div");
  wrap.className = "shopify-pc__prefs__trust-badges";
  wrap.innerHTML = `
    <span class="badge-trust">${t("cookie_prefs.trust_gdpr", "✓ GDPR")}</span>
    <span class="badge-trust badge-trust--eu">${t("cookie_prefs.trust_eu", "🇪🇺 Server EU")}</span>
    <span class="badge-trust badge-trust--anpc">${t("cookie_prefs.trust_anpc", "⚖ ANPC")}</span>
  `;
  header.appendChild(wrap);
}

function injectNecesarLegalNote(dialog) {
  const essential = dialog.querySelector("#shopify-pc__prefs__essential");
  if (!essential || essential.querySelector(".shopify-pc__prefs__legal-note")) return;

  const note = document.createElement("p");
  note.className = "shopify-pc__prefs__legal-note";
  note.textContent = t("cookie_prefs.necesar_legal", "Nu poate fi dezactivat — necesar legal.");
  essential.appendChild(note);
}

function regionLabel(key) {
  return t(`cookie_prefs.region_${key}`, REGION_FALLBACK[key] || key.toUpperCase());
}

function noteLabel(key) {
  return t(`cookie_prefs.vendor_${key}`, NOTE_FALLBACK[key] || "");
}

function injectVendorAccordions(dialog) {
  Object.entries(VENDOR_DATA).forEach(([key, vendors]) => {
    const option = dialog.querySelector(`#shopify-pc__prefs__${key}`);
    if (!option || option.querySelector(".shopify-pc__prefs__vendor-details")) return;

    const count = vendors.length;
    const countLabel = count === 1
      ? t("cookie_prefs.vendors_count_one", "1 partener")
      : t("cookie_prefs.vendors_count", "%COUNT% parteneri").replace("%COUNT%", count);

    const details = document.createElement("details");
    details.className = "shopify-pc__prefs__vendor-details";

    const summary = document.createElement("summary");
    summary.textContent = countLabel;
    details.appendChild(summary);

    const body = document.createElement("div");
    body.className = "shopify-pc__prefs__vendor-body";

    if (vendors.length === 1) {
      const v = vendors[0];
      const region = regionLabel(v.regionKey);
      const note = v.noteKey ? noteLabel(v.noteKey) : "";
      body.innerHTML = `<strong>${escapeHtml(v.name)}</strong> (${escapeHtml(region)})${note ? ` — ${escapeHtml(note)}` : ""}`;
    } else {
      const list = document.createElement("ul");
      vendors.forEach((v) => {
        const li = document.createElement("li");
        const region = regionLabel(v.regionKey);
        li.innerHTML = `<strong>${escapeHtml(v.name)}</strong> ${
          v.crossBorder
            ? `<span class="xb">${escapeHtml(region)}</span>`
            : `(${escapeHtml(region)})`
        }`;
        list.appendChild(li);
      });
      body.appendChild(list);
    }

    details.appendChild(body);
    option.appendChild(details);
  });
}

function reorganizeFooter(dialog) {
  const headerActions = dialog.querySelector(".shopify-pc__prefs__header-actions");
  if (!headerActions || dialog.querySelector(".shopify-pc__prefs__custom-footer")) return;

  const accept = headerActions.querySelector("#shopify-pc__prefs__header-accept");
  const decline = headerActions.querySelector("#shopify-pc__prefs__header-decline");
  const save = headerActions.querySelector("#shopify-pc__prefs__header-save");

  const footer = document.createElement("div");
  footer.className = "shopify-pc__prefs__custom-footer";

  const actionsRow = document.createElement("div");
  actionsRow.className = "shopify-pc__prefs__custom-footer__actions";

  if (decline) {
    const declineBtn = document.createElement("button");
    declineBtn.type = "button";
    declineBtn.className = "shopify-pc__prefs__custom-footer__btn shopify-pc__prefs__custom-footer__btn--decline";
    declineBtn.textContent = decline.textContent.trim();
    declineBtn.addEventListener("click", () => decline.click());
    actionsRow.appendChild(declineBtn);
  }

  if (accept) {
    const acceptBtn = document.createElement("button");
    acceptBtn.type = "button";
    acceptBtn.className = "shopify-pc__prefs__custom-footer__btn shopify-pc__prefs__custom-footer__btn--accept";
    acceptBtn.textContent = accept.textContent.trim();
    acceptBtn.addEventListener("click", () => accept.click());
    actionsRow.appendChild(acceptBtn);
  }

  footer.appendChild(actionsRow);

  if (save) {
    const saveBtn = document.createElement("button");
    saveBtn.type = "button";
    saveBtn.className = "shopify-pc__prefs__custom-footer__save";
    saveBtn.textContent = save.textContent.trim();
    saveBtn.addEventListener("click", () => save.click());
    footer.appendChild(saveBtn);
  }

  dialog.appendChild(footer);
}

function injectLegalFoot(dialog) {
  if (dialog.querySelector(".shopify-pc__prefs__legal-foot")) return;

  const foot = document.createElement("div");
  foot.className = "shopify-pc__prefs__legal-foot";
  foot.innerHTML = `
    <a href="/policies/privacy-policy">${t("cookie_prefs.legal_privacy", "Politica de confidențialitate")}</a> ·
    <a href="/policies/privacy-policy#cookies">${t("cookie_prefs.legal_cookies", "Cookies")}</a> ·
    ${t("cookie_prefs.legal_compliance", "Conform GDPR + ANPC")}
  `;
  dialog.appendChild(foot);
}

function escapeHtml(str) {
  return String(str).replace(/[&<>"']/g, (m) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  }[m]));
}

const observer = new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (node.nodeType !== 1) continue;
      const dialog = node.id === "shopify-pc__prefs__dialog"
        ? node
        : node.querySelector?.("#shopify-pc__prefs__dialog");
      if (dialog) enhanceDialog(dialog);
      if (
        node.id === "shopify-pc__banner" ||
        node.querySelector?.("#shopify-pc__banner")
      ) {
        neutralizeBannerHeading();
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

const existingDialog = document.querySelector("#shopify-pc__prefs__dialog");
if (existingDialog) enhanceDialog(existingDialog);

neutralizeBannerHeading();
